import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import CountryForm from '../../../components/forms/CountryForm';
import { useCreateCountry } from '../../../hooks/useCountryApi';
import { useNavigate } from 'react-router-dom';
import { CountryDTO } from '../../../services/apiClient';

const CountryCreate: React.FC = () => {
  const createCountry = useCreateCountry();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Countries', href: '/admin/countries' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: CountryDTO) => {
    try {
      await createCountry.mutateAsync(data);
      navigate('/admin/countries');
    } catch (error) {
      console.error('Error creating Country:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/countries"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.Country.Edit'
    >
        <CountryForm
          initialValues={{} as CountryDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/countries')}
        />
    </AdminLayout>
  );
};

export default CountryCreate;